/** @format */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import compose from 'recompose/compose';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import PropTypes from 'prop-types';
import I18n from '../../components/Translate/I18n';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import ActionButton from '../../components/Buttons/CustomTextButton';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { connect } from 'react-redux';
import AlertInfo from '../../components/Info/AlertInfo';
import InputFormRest from '../../components/Form/InputFormRest';
import { operationOnSimcardActions, operationOnSimcardConstants } from '../../modules/simcard/operationOnSimcard';
import { notificationConstants } from '../../modules/notifications/notifications';
import { OperatorMvneTypeMap } from '../../modules/lib/hooks/useOperatorType';
import { AlertDialog } from '../lib/dialog/AlertDialog';
import {CurrencyHelper} from "../../helpers/CurrencyHelper";

const directionAdjustment = {
    UP: 1,
    DOWN: 2,
    DIRECT_SET: 3,
};

class AdjustmentAccount extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            entity: {
                adjustmentAccount: null,
            },
            entityStatus: {
                adjustmentAccount: null,
            },
            reloadAccount: false,
            alert: null,
            simCard: this.props.simCard,
        };
    }

    change = (e, stateName, type, require, maxValue, minValue) => {
        FormGeneralHelper.validateForms(this, e, stateName, type, require, maxValue, minValue, () => {
            this.setState({ reloadAccount: true });
        });
    };

    cancelActivate = () => {
        this.setState({ alert: null });
    };

    clearInputField = () => {
        this.setState({ reloadAccount: false, entity: { adjustmentAccount: null } });
    };

    prepareValue = (callBack) => {
        if (this.state.entity.adjustmentAccount) {
            const number = parseFloat(this.state.entity.adjustmentAccount);
            this.setState(
                {
                    entity: {
                        adjustmentAccount: number.toFixed(2),
                    },
                },
                callBack
            );
        } else {
            callBack();
        }
    };

    activateFeatureConfirm = () => {
        console.log(this.state.entity);
        if (this.state.entity.adjustmentAccount === null || this.state.entity.adjustmentAccount.length === 0) {
            this.clearInputField();
            return;
        }
        this.prepareValue(() => {
            this.setState({
                alert: (
                    <AlertDialog
                        displayMessageValueObject={{amount: CurrencyHelper.numericToStandardPln(this.state.entity.adjustmentAccount) }}
                        open={!this.state.alert}
                        titleDialog="simcard:a.adjustment_account"
                        displayMessage="simcard:a.confirm_adjustment_account"
                        closeCallback={this.cancelActivate}
                        confirmCallback={this.reloadAccount}
                    />
                ),
            });
        });
    };

    reloadAccount = () => {
        this.setState({ change: false }, () => {
            const { dispatch, simCard } = this.props;

            let direction = directionAdjustment.UP;
            const newBalance = parseFloat(this.state.entity.adjustmentAccount);
            let adjustment = 0;
            direction = directionAdjustment.DIRECT_SET;
            adjustment = newBalance;
            const params = {
                id: simCard.id,
                accountAdjustmentEvent: true,
                accountAdjustment: adjustment,
                accountAdjustmentDirection: direction,
            };
            this.setState(
                {
                    alert: null,
                },
                () => {
                    dispatch(
                        operationOnSimcardActions.put(
                            FormGeneralHelper.getUrl('/operation_on_sim_card_balances/' + simCard.id),
                            params,
                            operationOnSimcardConstants.SIM_CARD_ACTIVATE_PUT,
                            (data) => {
                                this.props.refreshPage();
                            },
                            { propagateDataToCallback: true }
                        )
                    );
                }
            );
        });
    };

    static getDerivedStateFromProps(props, state) {
        if (props.type && props.type === notificationConstants.ERROR) {
            state.alert = null;
        }
        return state;
    }

    render() {
        const { classes } = this.props;
        const { alert, reloadAccount, entity, entityStatus } = this.state;
        return (
            <GridContainer>
                <GridItem xs={12}>
                    <I18n trans="simcard:a.adjustment_account" />
                </GridItem>
                <GridItem xs={12}>
                    <InputFormRest
                        classes={classes}
                        callback={this.change}
                        stateName="adjustmentAccount"
                        stateObjectState={entityStatus.adjustmentAccount}
                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                        typeField={FormGeneralHelper.TYPE_NUMBER_EXT_INTEGER}
                        displayFieldName="simcard:a.adjustment_amount"
                        vMax={-1}
                        vMin={-1}
                        required={false}
                        value={entity.adjustmentAccount}
                    />
                </GridItem>
                {reloadAccount && (
                    <GridItem xs={12}>
                        <ActionButton callback={this.activateFeatureConfirm} callbackParam={{}} label="simcard:a.do_adjustment_account" size="sm" />
                    </GridItem>
                )}
                {alert}
            </GridContainer>
        );
    }
}

AdjustmentAccount.propTypes = {
    classes: PropTypes.object.isRequired,
    simCard: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    const { notify } = state;
    if (notify && notify.type === notificationConstants.ERROR) {
        return {
            type: notificationConstants.ERROR,
        };
    }
    return {};
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(AdjustmentAccount);
export default Enhance;
